import React from "react";
import Meanings from "./Meanings";
import Phonetics from "./Phonetics";
import "./App.css";

export default function Results(props) {
  if (props.results) {
    if (props.results.error) {
      return (
        <div className="subtitle-font">
          Sorry, we could not find a definition.
        </div>
      );
    } else {
      return (
        <div className="results">
          <section>
            <h2 className="title-font searched-word">{props.results.word}</h2>
            <div className="title-font container">
              {props.results.phonetics.map(function (phonetics) {
                return <Phonetics phonetics={phonetics} />;
              })}
            </div>
          </section>

          {props.results.meanings.map(function (meanings, index) {
            return (
              <section key={index}>
                <Meanings meanings={meanings} />
              </section>
            );
          })}
        </div>
      );
    }
  } else {
    return null;
  }
}
